import { Routes } from '@angular/router';
import { HomeAdm } from './features/instituto-online/home-adm/home-adm';
import { ExtratoDesligamento } from './features/instituto-online/extrato-desligamento/extrato-desligamento';
import { TokenVerify } from './core/components/token-verify/token-verify';
import { TokenInvalido } from './features/token-invalido/token-invalido';
import { Home } from './features/instituto-online/home/home';
import { EscolhaInstituto } from './features/instituto-online/escolha-instituto/escolha-instituto';
import {
  MENSAGEM_REQUERIMENTO_INDISPONIVEL,
  PaginaIndisponivel,
} from './features/instituto-online/pagina-indisponivel/pagina-indisponivel';
import { authGuard } from './core/session/auth.guard';
import { requerimentoTokenGuard } from './core/session/requerimento-token.guard';
import { DadosCadastrais } from './features/instituto-online/dados-cadastrais/dados-cadastrais';
import { ModalidadeIr } from './features/instituto-online/modalidade-ir/modalidade-ir';
import { UploadDocumentos } from './features/instituto-online/upload-documentos/upload-documentos';
import { Resumo } from './features/instituto-online/resumo/resumo';
import { AssinaturaTermo } from './features/instituto-online/assinatura-termo/assinatura-termo';
import { DetalhesInstituto } from './features/instituto-online/detalhes-instituto/detalhes-instituto';
import { HomeRequerimento } from './features/requerimento-beneficio/home/home-requerimento';
import { homeRequerimentoResolver } from './features/requerimento-beneficio/home/home-requerimento.resolver';
import { DadosCadastraisRequerimento } from './features/requerimento-beneficio/dados-cadastrais/dados-cadastrais-requerimento';
import { ConfiguracaoBeneficio } from './features/requerimento-beneficio/configuracao-beneficio/configuracao-beneficio';
import { ModalidadeImposto } from './features/requerimento-beneficio/modalidade-imposto/modalidade-imposto';
import { Beneficiario } from './features/requerimento-beneficio/beneficiario/beneficiario';
import { UploadDocumento } from './features/requerimento-beneficio/upload-documento/upload-documento';
import { ResumoRequerimento } from './features/requerimento-beneficio/resumo/resumo-requerimento';
import { AssinaturaTermoRequerimento } from './features/requerimento-beneficio/assinatura-termo/assinatura-termo-requerimento';
import { DetalhesRequerimento } from './features/requerimento-beneficio/detalhes/detalhes-requerimento';
import { Autopatrocinio } from './features/instituto-online/autopatrocinio/autopatrocinio';
import { AssinaturaTermoMvp } from './features/instituto-online/assinatura-termo-mvp/assinatura-termo-mvp';
import { ResgateMvp } from './features/instituto-online/resgate-mvp/resgate-mvp';
import { DetalhesMvp } from './features/instituto-online/detalhes-mvp/detalhes-mvp';

export const routes: Routes = [
    { path: '', component: HomeAdm },
    { path: 'token-invalido', component: TokenInvalido },
    { path: 'token-verify', component: TokenVerify },
    { path: 'instituto-online/pagina-indisponivel', component: PaginaIndisponivel },
    {
      path: 'requerimento-beneficio/pagina-indisponivel',
      component: PaginaIndisponivel,
      data: { mensagem: MENSAGEM_REQUERIMENTO_INDISPONIVEL },
    },
    { path: 'instituto-online/home', component: Home, canActivate: [authGuard] },
    { path: 'instituto-online/extrato-desligamento', component: ExtratoDesligamento, canActivate: [authGuard] },
    { path: 'instituto-online/escolha-instituto', component: EscolhaInstituto, canActivate: [authGuard] },
    { path: 'instituto-online/dados-cadastrais', component: DadosCadastrais, canActivate: [authGuard] },
    { path: 'instituto-online/modalidade-ir', component: ModalidadeIr, canActivate: [authGuard] },
    { path: 'instituto-online/upload-documentos', component: UploadDocumentos, canActivate: [authGuard] },
    { path: 'instituto-online/resumo', component: Resumo, canActivate: [authGuard] },
    { path: 'instituto-online/assinatura-termo', component: AssinaturaTermo, canActivate: [authGuard] },
    { path: 'instituto-online/assinatura-termo-mvp', component: AssinaturaTermoMvp, canActivate: [authGuard] },
    { path: 'instituto-online/detalhes', component: DetalhesInstituto, canActivate: [authGuard] },
    { path: 'instituto-online/detalhes-mvp', component: DetalhesMvp, canActivate: [authGuard] },
    { path: 'instituto-online/autopatrocinio', component: Autopatrocinio, canActivate: [authGuard] },
    { path: 'instituto-online/resgate-mvp', component: ResgateMvp, canActivate: [authGuard] },
    {
      path: 'requerimento-beneficio',
      component: HomeRequerimento,
      canActivate: [requerimentoTokenGuard],
      resolve: { home: homeRequerimentoResolver },
    },
    { path: 'requerimento-beneficio/dados-cadastrais', component: DadosCadastraisRequerimento },
    { path: 'requerimento-beneficio/configuracao-beneficio', component: ConfiguracaoBeneficio },
    { path: 'requerimento-beneficio/modalidade-imposto', component: ModalidadeImposto },
    { path: 'requerimento-beneficio/beneficiarios', component: Beneficiario },
    { path: 'requerimento-beneficio/upload-documento', component: UploadDocumento },
    { path: 'requerimento-beneficio/resumo', component: ResumoRequerimento },
    { path: 'requerimento-beneficio/assinatura-termo', component: AssinaturaTermoRequerimento },
    { path: 'requerimento-beneficio/detalhes', component: DetalhesRequerimento },
];    